import React, { useState, useEffect, useRef } from "react";
import { Icon } from "@blueprintjs/core";

export default function FilledButtonWithDropdown({
  text,
  onClick,
  menuItems = [],
  disabled = false
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = e => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () =>
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );
  }, []);

  const styles = {
    wrapper: {
      position: "relative",
      display: "inline-flex"
    },

    buttonWrapper: {
      display: "flex",
      alignItems: "center",
      background: "#1870d5",
      borderRadius: "25px",
      overflow: "hidden"
    },

    mainButton: {
      background: "transparent",
      color: "#fff",
      border: "none",
      outline: "none",
      cursor: disabled ? "not-allowed" : "pointer",
      padding: "10px 22px",
      opacity: disabled ? 0.5 : 1
    },

    arrowButton: {
      width: "42px",
      background: "transparent",
      border: "none",
      borderLeft: "1px solid rgba(255,255,255,.35)",
      color: "#fff",
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      opacity: disabled ? 0.5 : 1
    },

    dropdown: {
      position: "absolute",
      top: "calc(100% + 10px)",
      right: 0,
      minWidth: "280px",
      background: "#fff",
      borderRadius: "16px",
      boxShadow: "0 10px 30px rgba(0,0,0,.12)",
      border: "1px solid #ebedf0",
      padding: "8px 0",
      zIndex: 1000
    },

    menuItem: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      width: "100%",
      padding: "12px 18px",
      background: "#fff",
      border: "none",
      cursor: "pointer",
      textAlign: "left"
    },

    iconBox: {
      width: "36px",
      height: "36px",
      borderRadius: "10px",
      background: "#eef4ff",
      color: "#1870d5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    },
  };

  return (
    <div ref={wrapperRef} style={styles.wrapper}>
      <div
        style={{
          ...styles.buttonWrapper,
          background: open ? "#0a53a8" : "#1870d5"
        }}
      >
        <button
          style={styles.mainButton}
          disabled={disabled}
          onClick={onClick}
        >
          {text}
        </button>

        <button
          style={styles.arrowButton}
          disabled={disabled}
          onClick={() => setOpen(!open)}
        >
          <Icon
            icon={open ? "chevron-up" : "chevron-down"}
            size={14}
            color="white"
          />
        </button>
      </div>

      {open && (
        <div style={styles.dropdown}>
          {menuItems.map((item, index) => (
            <button
              key={index}
              style={styles.menuItem}
              onClick={() => {
                setOpen(false);
                item.onClick?.();
              }}
              onMouseEnter={e =>
                (e.currentTarget.style.background = "#f7f9fc")
              }
              onMouseLeave={e =>
                (e.currentTarget.style.background = "#fff")
              }
            >
              <div style={styles.iconBox}>
                <Icon icon={item.icon} size={18} />
              </div>

              <span style={styles.text}>{item.text}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}




// import React from "react";
// import style from "./Buttons.module.css";
// export default function FilledButtonWithDropdown(props) {
//   const { text, onToggle, btnClass = "", ...restProps } = props;
//   return (
//     <div className={style.buttonWithDropdownWarpper}>
//       <div>
//         <button className={`${style.filledBtnInDropdown} ${btnClass}`} {...restProps}>
//           {text}
//         </button>
//         <button className={style.filledArrowInDropdown} onClick={onToggle}>
//             <img src="/resources/app/images/white_down_icon.svg" alt="dropdown" />
//         </button>
//       </div>
//     </div>
//   );
// }
